import React from "react";
import { History } from "history";
import moment from "moment";
import NumberFormat from "react-number-format";

import {
  Box,
  Row,
  Col,
  CampoEstatico,
  TipoCampoEstatico,
  Combo,
  Form,
  CampoValor,
  PosicaoTituloCampoValor,
  Alerta,
  TipoAlerta,
  Botao,
} from "@intechprev/componentes-web";

import { Page } from "../..";
import {
  ContratoEmprestimoService,
  PlanoVinculadoService,
} from "../../../services";
import {
  PlanoVinculadoEntidade,
  ContratoEmprestimoEntidade,
  NaturezaEmprestimoEntidade,
} from "../../../entidades";

export interface IParametrosSimulacao {
  valorSolicitado: number;
  natureza: NaturezaEmprestimoEntidade;
  plano: PlanoVinculadoEntidade;
  prestacao?: any;
  tabela?: string;

  valorJurosAdicional?: number;
  valorCorrecao?: number;
}

interface Props {
  history?: History;
}

interface State {
  sqPlano: number;
  plano: PlanoVinculadoEntidade;
  listaPlanos: PlanoVinculadoEntidade[];

  sqNatureza: number;
  natureza: NaturezaEmprestimoEntidade;
  listaNaturezas: NaturezaEmprestimoEntidade[];

  contratos: ContratoEmprestimoEntidade[];
  dadosSimulacao?: any;

  valorSolicitado: number;
  erro: string;
}

export class EmprestimosSimulador extends React.Component<Props, State> {
  private page = React.createRef<Page>();
  private form = React.createRef<Form>();
  private alert = React.createRef<Alerta>();

  state: State = {
    sqPlano: 0,
    plano: null,
    listaPlanos: [],

    sqNatureza: 0,
    natureza: null,
    listaNaturezas: [],

    contratos: [],
    dadosSimulacao: null,

    valorSolicitado: 0,
    erro: ""
  };

  componentDidMount = async () => {
    this.page.current.loading(true);

    try {
      const listaPlanos = await PlanoVinculadoService.Buscar();
      const listaNaturezas = await ContratoEmprestimoService.BuscarNaturezasEmVigencia();

      await this.setState({
        listaPlanos,
        listaNaturezas,
      });

      await this.carregarDados();
    }
    catch (e) {
      const err: any = e;
      this.setState({
        erro: err.response ? err.response.data : err
      });
    }
    finally {
      this.page.current.loading(false);
    }
  };

  carregarDados = async () => {
    if (!this.state.sqPlano) {
      await this.setState({
        sqPlano: this.state.listaPlanos[0].SQ_PLANO_PREVIDENCIAL,
      });
    }

    if (!this.state.sqNatureza) {
      await this.setState({
        sqNatureza: this.state.listaNaturezas[0].SQ_NATUREZA,
      });
    }

    const plano = this.state.listaPlanos.filter(
      (plano) => plano.SQ_PLANO_PREVIDENCIAL === this.state.sqPlano
    )[0];

    const natureza = this.state.listaNaturezas.filter(
      (natureza) => natureza.SQ_NATUREZA === this.state.sqNatureza
    )[0];

    const contratos = await ContratoEmprestimoService.Buscar();

    const dadosSimulacao = await ContratoEmprestimoService.BuscarDadosSimulacao(
      this.state.sqPlano,
      this.state.sqNatureza
    );

    await this.setState({
      plano,
      natureza,
      contratos,
      dadosSimulacao: dadosSimulacao.Resultado,
      valorSolicitado: dadosSimulacao.Resultado.ValorMaximoDisponivel
    });
  };

  continuar = async () => {
    await this.alert.current.limparErros();
    await this.form.current.validar();

    if (this.state.valorSolicitado || this.state.valorSolicitado.toString().trim() !== "") {

      if (this.state.valorSolicitado > this.state.dadosSimulacao.ValorMaximoDisponivel) {
        await this.alert.current.adicionarErro(
          "O valor solicitado não pode ser superior ao valor \"Disponível\"."
        );
      }

      if (
        this.alert.current.state.mensagem.length === 0 &&
        this.alert.current.props.mensagem.length === 0
      ) {
        var dados: IParametrosSimulacao = {
          valorSolicitado: this.state.valorSolicitado,
          plano: this.state.plano,
          natureza: this.state.natureza
        };

        await localStorage.setItem(
          "emprestimo-parametros",
          JSON.stringify(dados)
        );
        this.props.history.push("/emprestimosSimuladorPrestacoes");
      }
    }
  };

  render() {
    return (
      <Page {...this.props} ref={this.page}>
        {this.page.current && (
          <>
            {this.state.erro && <Alerta tipo={TipoAlerta.danger} mensagem={this.state.erro} />}

            {!this.state.erro &&
              <>
                <h3>Bem-Vindo ao Simulador de Empréstimos da EQTPREV!</h3>
                <h5>
                  Ao final da sua simulação você poderá realizar o requerimento do
                  seu empréstimo diretamente por aqui, de forma on-line e segura!
                </h5>

                <Box titulo={"Selecione um Plano para a Simulação"}>
                  <Combo
                    contexto={this}
                    nome={"sqPlano"}
                    valor={this.state.sqPlano}
                    opcoes={this.state.listaPlanos}
                    padrao={this.state.sqPlano}
                    onChange={this.carregarDados}
                    nomeMembro={"DS_PLANO_PREVIDENCIAL"}
                    valorMembro={"SQ_PLANO_PREVIDENCIAL"}
                  />
                </Box>

                <Box titulo={"Natureza do Empréstimo"}>
                  <Combo
                    contexto={this}
                    nome={"sqNatureza"}
                    valor={this.state.sqNatureza}
                    opcoes={this.state.listaNaturezas}
                    padrao={this.state.sqNatureza}
                    onChange={this.carregarDados}
                    nomeMembro={"DS_NATUREZA"}
                    valorMembro={"SQ_NATUREZA"}
                  />
                </Box>

                {this.state.dadosSimulacao && (
                  <>
                    {(this.state.dadosSimulacao.mensagem) &&
                      <Alerta
                        mensagem={this.state.dadosSimulacao.mensagem}
                        tipo={TipoAlerta.danger}
                      />
                    }

                    {(!this.state.dadosSimulacao.mensagem) &&
                      <>
                        <Row className={"text-center"}>
                          <Col>
                            <Box>
                              <h4 style={{ fontWeight: "bold" }}>Limite Máximo</h4>
                              <p style={{ fontSize: 12 }}>
                                Valor limite para concessão de empréstimo
                              </p>
                              <h3 className={"text-primary"}>
                                <CampoEstatico
                                  valor={this.state.dadosSimulacao.ValorMaximoEmprestimo}
                                  tipo={TipoCampoEstatico.dinheiro}
                                />
                              </h3>
                            </Box>
                          </Col>
                          <Col>
                            <Box>
                              <h4 style={{ fontWeight: "bold" }}>
                                Recurso Já Utilizado
                              </h4>
                              <p style={{ fontSize: 12 }}>
                                Saldo de empréstimos ativos
                              </p>
                              <h3 className={"text-secondary"}>
                                <CampoEstatico
                                  valor={this.state.dadosSimulacao.ValorSaldoReforma}
                                  tipo={TipoCampoEstatico.dinheiro}
                                />
                              </h3>
                            </Box>
                          </Col>
                          <Col>
                            <Box>
                              <h4 style={{ fontWeight: "bold" }}>Disponível</h4>
                              <p style={{ fontSize: 12 }}>
                                Valor que você pode requerer
                              </p>
                              <h3 className={"text-primary"}>
                                <CampoEstatico
                                  valor={this.state.dadosSimulacao.ValorMaximoDisponivel}
                                  tipo={TipoCampoEstatico.dinheiro}
                                />
                              </h3>
                            </Box>
                          </Col>
                        </Row>

                        <Row className={"text-center"}>
                          <Col>
                            <Box>
                              <h4 style={{ fontWeight: "bold" }}>
                                Prazo Máximo (Meses)
                              </h4>
                              <p style={{ fontSize: 12 }}>
                                Quantidade máxima de prestações
                              </p>
                              <h3 className={"text-success"}>
                                <CampoEstatico
                                  valor={this.state.dadosSimulacao.QuantidadePrazoMaximo}
                                  tipo={TipoCampoEstatico.texto}
                                />
                              </h3>
                            </Box>
                          </Col>
                          <Col>
                            <Box>
                              <h4 style={{ fontWeight: "bold" }}>Prestação Limite</h4>
                              <p style={{ fontSize: 12 }}>Valor máximo de prestação</p>
                              <h3 className={"text-success"}>
                                <CampoEstatico
                                  valor={this.state.dadosSimulacao.ValorMaximoPrestacao}
                                  tipo={TipoCampoEstatico.dinheiro}
                                />
                              </h3>
                            </Box>
                          </Col>
                          <Col>
                            <Box>
                              <h4 style={{ fontWeight: "bold" }}>Data de Crédito</h4>
                              <p style={{ fontSize: 12 }}>
                                Data do crédito do empréstimo
                              </p>
                              <h3 className={"text-primary"}>
                                <CampoEstatico
                                  valor={moment(
                                    this.state.dadosSimulacao.DataCredito
                                  ).format("DD/MM/YYYY")}
                                />
                              </h3>
                            </Box>
                          </Col>
                        </Row>

                        <Box titulo={"Parâmetros para Simulação"}>
                          <Form ref={this.form}>
                            <Row formGroup>
                              <div className={"col col-md-12 col-form-label"}>
                                <b>
                                  <label htmlFor={"valorSolicitado"}>
                                    Valor Desejado de Empréstimo
                                  </label>
                                </b>
                              </div>

                              <Col>
                                <NumberFormat
                                  name={"valorSolicitado"}
                                  id={"valorSolicitado"}
                                  className={"form-control"}
                                  thousandSeparator={"."}
                                  decimalSeparator=","
                                  allowedDecimalSeparators={["."]}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  value={this.state.valorSolicitado}
                                  onValueChange={(e) => this.setState({ valorSolicitado: Number(e.value) })}
                                />
                              </Col>
                            </Row>

                            {this.state.dadosSimulacao.emprestimosAtivos.length > 0 && (
                              <>
                                <p className={"mt-5"}>
                                  Você já possui 1 contrato ativo que será reformado.
                                </p>
                                <table className={"table table-hover"}>
                                  <thead>
                                    <tr>
                                      <th>Nº/Ano</th>
                                      <th>Crédito</th>
                                      <th>Valor Solicitado</th>
                                      <th>Saldo Devedor</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.dadosSimulacao.emprestimosAtivos.map(
                                      (info: any, index: number) => {
                                        return (
                                          <tr
                                            key={index}
                                            style={{ cursor: 'pointer' }}
                                          >
                                            <td>{`${info.NumeroContrato}/${moment(info.DataSolicitacao, "DD/MM/YYYY HH:mm:SS").format('YYYY')}`}</td>
                                            <td>{info.DataCredito.toString().split(' ')[0]}</td>
                                            <td>
                                              <CampoEstatico
                                                valor={info.ValorSolicitado}
                                                tipo={TipoCampoEstatico.dinheiro}
                                              />
                                            </td>
                                            <td>
                                              <CampoEstatico
                                                valor={info.ValorSaldo}
                                                tipo={TipoCampoEstatico.dinheiro}
                                              />
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </>
                            )}

                            <Botao
                              titulo={"Calcular Prazos"}
                              onClick={this.continuar}
                              submit
                            />
                            <br />
                            <br />
                            <Alerta
                              ref={this.alert}
                              padraoFormulario
                              tipo={TipoAlerta.danger}
                              tamanho={"6"}
                            />
                          </Form>
                        </Box>
                      </>
                    }
                  </>
                )}
              </>
            }
          </>
        )}
      </Page>
    );
  }
}
